// 商家价格启用/禁用字典
export const enabledDic = [
  { label: "启用", value: 1 },
  { label: "禁用", value: 0 },
];

// 通用商家价格表格 option（防水/回填共用列配置）
export const merchantTableOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: true,
  showHeader: true,
  index: true,
  indexLabel: "序号",
  selection: true,
  menu: true,
  menuWidth: 160,
  page: true,
  addBtn: false,
  editBtn: false,
  menuType: "text",
  delBtn: false,
  viewBtn: false,
  column: [
    {
      label: "商户电话",
      prop: "merchantPhone",
      search: true,
      searchPlaceholder: "请输入商户电话",
      type: "input",
      minWidth: 160,
      rules: [{ required: true, message: "请输入商户电话", trigger: "blur" }],
    },
    {
      label: "商户名称",
      prop: "merchantName",
      search: true,
      searchPlaceholder: "请输入商户名称",
      type: "input",
      minWidth: 180,
    },
    {
      label: "面积单价",
      prop: "unitPrice",
      type: "number",
      minWidth: 120,
      precision: 2,
      min: 0,
      step: 0.5,
      controlsPosition: "right",
      rules: [{ required: true, message: "请输入面积单价", trigger: "blur" }],
    },
    {
      label: "面积阈值",
      prop: "thresholdSqm",
      type: "number",
      minWidth: 120,
      precision: 2,
      min: 0,
      step: 1,
      controlsPosition: "right",
      placeholder: "选填，不足则按阈值计",
    },
    {
      label: "状态",
      prop: "enabled",
      type: "switch",
      width: 100,
      value: 1,
      dicData: enabledDic,
    },
  ],
};

// 弹窗表单列（avue-crud 内置弹窗用）
export const merchantFormOption = {
  submitText: "确定",
  emptyBtnText: "取消",
  column: [
    {
      label: "商户电话",
      prop: "merchantPhone",
      type: "input",
      span: 24,
      rules: [{ required: true, message: "请输入商户电话", trigger: "blur" }],
    },
    {
      label: "商户名称",
      prop: "merchantName",
      type: "input",
      span: 24,
    },
    {
      label: "面积单价",
      prop: "unitPrice",
      type: "number",
      span: 24,
      precision: 2,
      min: 0,
      step: 0.5,
      controlsPosition: "right",
      rules: [{ required: true, message: "请输入面积单价", trigger: "blur" }],
    },
    {
      label: "面积阈值",
      prop: "thresholdSqm",
      type: "number",
      span: 24,
      precision: 2,
      min: 0,
      step: 1,
      controlsPosition: "right",
    },
    {
      label: "状态",
      prop: "enabled",
      type: "switch",
      span: 24,
      value: 1,
    },
  ],
};
